export default __webpack_public_path__ + "static/media/e-sip-dpo-logo-a.b831f769.png";